import React, { useState, useEffect, useRef, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { Tooltip, Autocomplete, TextField, CircularProgress, Radio, RadioGroup, FormControlLabel, IconButton, FormControl, FormHelperText, Switch } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
import ClosedIcon from "@mui/icons-material/Close";
import { FaHotel } from "react-icons/fa";
import { MdEmail, MdLocationPin, MdInsertLink, MdCall, MdOutlineAttachFile } from "react-icons/md";
import { GiBreakingChain } from "react-icons/gi";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import { ScrollToTop, getChainIdLS, getUserRoleCodeFromStorage, isValidRole } from "../../../utils/utils";
import { updateMasterHotelActions } from "../../../store/actions/UpdateMasterHotel/UpdateMasterHotelActions";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import UploadImage from "./UploadImage";
import UploadApk from "./UploadApk";
import DualListBox from "./DualListBox";
import UploadCDSNs from "./UploadCDSNs";
import { debounce } from 'lodash';
// import EnableDisableHotelConfig from "./EnableDisableHotelConfig";

function ConfigurationNewHotel() {
  let userRoleCode = getUserRoleCodeFromStorage();
  const dispatch = useDispatch()
  const [hotelList, setHotelList] = useState([]);
  const [roomTypesMaster, setRoomTypesMaster] = useState([]);
  const [confirmDeleteHotel, setConfirmDeleteHotel] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteHotelPopUp, setDeleteHotelPopUp] = useState(false);
  const [cdnsShowPopUp, setCdnsShowPopUp] = useState(false);
  const [rowData, setRowData] = useState(false);
  const [editHotel, setEditHotel] = useState(false);
  const [editHotelUpdate, setEditHotelUpdate] = useState(false);
  const [createHotelSuccessMsg, setCreateHotelSuccessMsg] = useState('');
  const [editHotelSid, setEditHotelSid] = useState("");
  // const [editHotelChainId, setEditHotelChaind] = useState("");
  const [showHintChainId, setShowHintChainId] = useState(false);
  const [loader, setLoader] = useState(false);
  const [originalCdsns, setOriginalCdsns] = useState([]);
  const [chainIdApiErrorValidation, setChainIdApiErrorValidation] = useState("");
  const [showHintCdsns, setShowHintCdsns] = useState(false);
  const [showHintRoomType, setShowHintRoomType] = useState(false);
  const [viewType, setViewType] = useState("custom");
  const [viewTypeOnChange, setViewTypeOnChange] = useState(false);
  const [editApkProvider, setEditApkProvider] = useState(false);
  const [deleteLogo, setDeleteLogo] = useState(false);
  const [createUpdateFlag, setCreateUpdateFlag] = useState(false);
  const [confirmAPICall, setConfirmAPICall] = useState(false);
  const [confirmAPICalling, setConfirmAPICalling] = useState(false);

  const [showChainIdPopup, setShowChainIdPopup] = useState(false);
  const [cdsnsList, setCdsnsList] = useState([]);
  const [selectedCdsns, setSelectedCdsns] = useState([]);
  const recordsPerPage = 10;

  const [otp, setOtp] = useState("")
  const [otpValidation, setOtpValidation] = useState("")
  const [otpSendSuccess, setOtpSendSuccess] = useState("")
  const [otpSendError, setOtpSendError] = useState("")
  const [counter, setCounter] = useState(0)
  const [isLinkDisabled,setIsLinkDisabled] = useState(false)
  const [targetCdsnError, setTargetCdsnError] = useState("")

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    watch,
    trigger,
    clearErrors
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      autoMode: false, priority: "MEDIUM"
    },
  });

  const { chainId } = useSelector((state) => state.chainIdReducer);
  const { viewType: viewTypeNew } = useSelector((state) => state.viewTypeReducer);

  let validPermissionClassName = isValidRole("HOTEL_CONFIGURATION_MODIFY")
    ? ""
    : "btn-disable-permission";

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)

  const [disableAddNewAPK, setDisableAddNewAPK] = useState(false)

  const [viewTypePermission, setViewTypePermission] = useState(localStorage.getItem("viewType"))
  const [roomTypeDisabled, setRoomTypeDisabled] = useState(false)

  const [appNameMasterList, setAppNameMasterList] = useState([])
  const [searchText, setSearchText] = useState("");

  const [cancelPopupClearHotel, setCancelPopupClearHotel] = useState(false);
  
    // This stores the function to run if "Yes" is clicked in modal
    const [pendingClear, setPendingClear] = useState(null);

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false
      setViewTypePermission(localStorage.getItem("viewType"))
    }
    else {
      setViewTypePermission(viewTypeNew)
    }
  }, [viewTypeNew])

  useEffect(() => {
    clearErrors('roomTypes')
    if (viewType === "hotelApp") {
      setValue('roomTypes', []);
      setRoomTypeDisabled(true)
    } else {
      setRoomTypeDisabled(false)
    }
  }, [viewType])

  const onSubmit = (data) => {
    // if (confirmAPICall && editApkProvider === false && userRoleCode !== "ROLE_SUPER_ADMIN" && viewType === 'hotelApp') {
    //   setEditApkProvider(true);
    //   return;
    // }
    setEditApkProvider(false);
    let method = "POST";
    let url = "/hotel";
    if (editHotelUpdate) {
      method = "PUT"
      url = `/hotel?sid=${editHotelSid?.id}`
    }

    const payload = { ...data, active: true, viewType: viewType };
    if (userRoleCode === "ROLE_SUPER_ADMIN") {
      delete payload.appName
      delete payload.hotelChainId
    }
    if (!data.autoMode) {
      delete payload.priority
    }
    setLoader(true);
    callAPI(url, method, payload, { chainId: getChainIdLS() })
      .then(function (response) {
        reset({
          hotelName: '',
          hotelChainId: '',
          email: '',
          contactNo: '',
          address: '',
          zipCode: '',
          roomTypes: [],
          appName: '',
          latitude: '',
          longitude: '',
          cdsns: [],
          enterpriseChainId: "",
          priority: "MEDIUM"
        });
        setCreateHotelSuccessMsg(response?.message);
        setCreateUpdateFlag((prev) => !prev);
        hotelListApi();
        setEditHotelSid('');
        setViewTypeOnChange(false);
        setLoader(false);
        setOriginalCdsns([]);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  };

  const isHotelDeletedRef = useRef({
    isHotelDeletedModalData: null,
    userConformationModalData: null,
  });

  const isHotelLogoDeletedRef = useRef({
    isHotelLogoDeletedModalData: null,
    userConformationModalData: null,
  });

  const deleteLogoHotelPopUpHandler = (row) => {
    setDeleteLogo(true);
    const newModalRefData = {
      isHotelLogoDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isHotelLogoDeletedRef.current = newModalRefData;
  }

  const deleteHotelPopUpHandler = (row) => {
    setDeleteHotelPopUp(true);
    const newModalRefData = {
      isHotelDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isHotelDeletedRef.current = newModalRefData;
  }

  const deleteHotelHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteHotel === "") {
      return
    }

    if (confirmDeleteHotel === `Delete ${isHotelDeletedRef.current?.isHotelDeletedModalData.row.hotelName}`) {
      setConfirmValidate(false)
      const { row } = isHotelDeletedRef.current?.isHotelDeletedModalData;
      setLoader(true);
      callAPI(`hotel?sid=${row?.id}&otp=${otp}`, "DELETE", {}, { chainId: row?.chainID })
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isHotelDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isHotelDeletedRef.current = newModalRefData;
          hotelListApi();
          setLoader(false);
        })
        .catch((error) => {
          console.warn(error);
          setLoader(false);
        });
    }
    reset({
      hotelName: '',
      hotelChainId: '',
      email: '',
      contactNo: '',
      address: '',
      zipCode: '',
      roomTypes: [],
      appName: '',
      latitude: '',
      longitude: '',
      cdsns: [],
      enterpriseChainId: ""
    });
  }

  const cancelPopupHandlerClearHotel = () => {
    if (pendingClear) pendingClear();
    setPendingClear(null);
    setCancelPopupClearHotel(false);
  };

  const renderActionIcon = (row) => {
    return (
      isValidRole("HOTEL_CONFIGURATION_MODIFY") ? <>
        <UploadImage disabled={false} row={row} hotelListApi={hotelListApi} />
        <Tooltip title='Edit' arrow>
          <span><MdModeEditOutline
            className="edit-icon-enable"
            onClick={() => { setEditHotel(true); setEditHotelSid(row) }}
          /></span>
        </Tooltip>
        <Tooltip title={`${userRoleCode === "ROLE_SUPER_ADMIN" ? "Delete" : "Only Super Admin can delete"}`} className="cursor-pointer" arrow>
          {userRoleCode === "ROLE_SUPER_ADMIN" ? <DeleteIcon
            className="delete-icon-enable"
            onClick={() => {
              deleteHotelPopUpHandler(row);
            }}
          /> : <DeleteIcon
            className="delete-icon-disable"
          ></DeleteIcon>}
        </Tooltip>
        {/* <EnableDisableHotelConfig editHotelSid={editHotelSid} row={row} setLoader={setLoader} hotelServiceListApi={hotelListApi} /> */}
      </> :
        <>
          <UploadImage disabled={true} row={row} hotelListApi={hotelListApi} />
          <Tooltip title="Don't have permission to edit" arrow>
            <span>
              <MdModeEditOutline className="edit-icon-disable" />
            </span>
          </Tooltip>
          <Tooltip title="Don't have permission to delete" arrow>
            <DeleteIcon className="delete-icon-disable" />
          </Tooltip>
        </>
    );
  };

  const renderCDSNS = (row) => {
    const [item, ...items] = row?.cdsns;
    return row?.cdsns?.length > 0 ? <span className="cursor-pointer" onClick={() => { setCdnsShowPopUp(true); setRowData(row) }}>{item} {items.length > 0 && (
      <><span>...</span><span className="ms-2 cdsn-count">+{items?.length}</span></>
    )}</span> : (
      <div>N.A</div>
    )
  }
  const deleteImageHandler = () => {
    setLoader(true);
    callAPI(`/hotel-logo`, "DELETE", {}, { chainId: isHotelLogoDeletedRef.current?.isHotelLogoDeletedModalData?.row?.chainID })
      .then((response) => {
        let successMessage = response.message;
        const newModalRefData = {
          isHotelLogoDeletedModalData: null,
          userConformationModalData: {
            successMessage
          },
        };
        isHotelLogoDeletedRef.current = newModalRefData;
        hotelListApi();
        setLoader(false);
      })
      .catch((error) => {
        console.warn(error);
        setLoader(false);
      });
  }

  const columns = [
    { field: "hotelName", headerName: "Hotel Name", flex: 1 },
    { field: "contactNo", headerName: "Phone", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    {
      field: "CDSN", headerName: "Linked CDSNs", flex: 1,
      row: true, renderCell: renderCDSNS,
      sortDirection: false,
      disableSortIcon: true
    },
    {
      field: "logoUrl", headerName: "Logo", flex: 1,
      row: true, renderCell: (row) => row?.logoUrl === null ? "NA" : <div className="uploaded-image">
        <img src={row?.logoUrl} alt={row?.logoUrl} />
        {isValidRole("HOTEL_CONFIGURATION_MODIFY") ? <ClosedIcon
          className={`close-icon`}
          onClick={() => { deleteLogoHotelPopUpHandler(row) }}
        /> :
          <Tooltip title="Don't have permission to delete" arrow>
            <span>
              <ClosedIcon
                className={`close-icon actionButtonDisable`}
              // onClick={() => { deleteLogoHotelPopUpHandler(row) }}
              /></span></Tooltip>}
      </div>,
      sortDirection: false,
      disableSortIcon: true
    },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const hotelListApi = () => {
    const apiPath = `hotel/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    setLoader(true);
    callAPI(apiPath, "POST", { hotelName: searchText, isDashboardPage: false })
      .then((response) => {
        setHotelList(response?.hotelDetails?.map((data)=>({...data, sid:data.id})));
        const disableAPKFlag = [response?.hotelDetails.find((item) => item?.chainID === chainId?.chainId)]
        if (disableAPKFlag?.length) {
          if (disableAPKFlag[0]?.appName === null) {
            setDisableAddNewAPK(true)
          }
          else {
            setDisableAddNewAPK(false)
          }
        }
        // setUploadApkViewType(response?.hotelDetails[0]?.viewType);
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        setPaginationError("")
        dispatch(updateMasterHotelActions())
        setLoader(false);
      })
      .catch((err) => { console.warn(err.message); setLoader(false); });
  };

  useEffect(() => {
    hotelListApi();
    reset({
      hotelName: '',
      hotelChainId: '',
      email: '',
      contactNo: '',
      address: '',
      zipCode: '',
      roomTypes: [],
      appName: '',
      latitude: '',
      longitude: '',
      cdsns: [],
      enterpriseChainId: ""
    });
    setEditHotel(false);
    setEditHotelSid("")
  }, [selectedPage, chainId, searchText]);

  useEffect(() => {
    setInputPageValue(1)
    setPaginationError("")
    setSelectedPage(1);
  }, [searchText]);

  useEffect(() => {
    callAPI("/master/room-list", "GET")
      .then((res) => {
        setRoomTypesMaster(res?.roomType);
      })
      .catch((err) => {
        console.warn(err.message);
      });
    callAPI("/master/apk/apps", "GET")
      .then((res) => {
        const arrayResponse = res?.map((item) => item.appName)
        setAppNameMasterList(arrayResponse);
      })
      .catch((err) => {
        console.warn(err.message);
      });
  }, []);

  const handleKeyPress = (event) => {
    if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
      setShowHintChainId(false)
      setLoader(true);
      event.preventDefault();
      callAPI(`/master/master-cdsn?chainId=${watch('hotelChainId')}`, "GET")
        .then((res) => {
          setCdsnsList(res);
          setLoader(false);
          setChainIdApiErrorValidation("");
        })
        .catch((err) => {
          console.warn(err.message);
          setChainIdApiErrorValidation("Enter Valid Chain Id");
          setLoader(false);
        });
    }
  };

  const popupCloseHandler = () => {
    setDeleteHotelPopUp(false);
    setCdnsShowPopUp(false);
  };

  const DownloadTextFile = (headings, fileName) => {
    const columnHeaders = 'CDSN\n';
    const textArray = headings?.map((category) => {
      const categoryText = `${category?.header}\n`; // Section heading
      const categoryBody = category?.body?.map((item) =>
        `${item?.length ? item : 'NA'}`)?.join('\n'); // Data rows with SID and CDSN
      return `${categoryText}${columnHeaders}${categoryBody || 'No data available'}\n`; // Include the column headers before the data
    });

    const fileText = textArray?.join('\n');
    const blob = new Blob([fileText], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const downLoadFile = () => {
    const fileName = `${rowData?.hotelName}_${rowData?.hotelChainId}_CDSNs.csv`;
    const headings = [
      { header: `List of "${rowData?.hotelName}" Linked CDSN's`, body: rowData?.cdsns?.length ? rowData?.cdsns : [{ sid: 'NA', cdsn: ['NA'] }] }
    ];
    DownloadTextFile(headings, fileName);
  };

  useEffect(() => {
    if (editHotel && editHotelSid?.id) {
      getHotelListSidHandler();
      setEditHotel(false);
    }
    ScrollToTop();
  }, [editHotel, editHotelSid]);

  const getHotelListSidHandler = () => {
    if (!editHotelSid?.id) {
      return;
    }
    setLoader(true);
    callAPI(`hotel?sid=${editHotelSid?.id}`, "GET")
      .then(function (response) {
        setViewTypeOnChange(false);
        const payload = {
          hotelName: response?.hotelName,
          email: response?.email,
          contactNo: response?.contactNo,
          address: response?.address,
          zipCode: response?.zipCode,
          roomTypes: response.roomType,
          appName: response?.appName,
          latitude: response?.latitude,
          longitude: response?.longitude,
          cdsns: response.cdsns,
          autoMode: response.autoMode,
          priority: response.priority?response.priority:"MEDIUM",
          enterpriseChainId: response?.entepriseChainId ? parseInt(response.entepriseChainId) : ''
        };
        // setEditHotelChaind(response?.hotelChainId);
        setViewType(response?.viewType);
        setOriginalCdsns(response.cdsns);
        reset(payload);
        setEditHotelUpdate(true);
        setChainIdApiErrorValidation("");
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  }

  const resetLayoutHandler = () => {
    reset();
    setChainIdApiErrorValidation("");
    setEditApkProvider(false)
  }

  const cancelHotelHandler = () => {
    reset({
      hotelName: '',
      hotelChainId: '',
      email: '',
      contactNo: '',
      address: '',
      zipCode: '',
      roomTypes: [],
      appName: '',
      latitude: '',
      longitude: '',
      cdsns: [],
      enterpriseChainId: "",
    });
    setEditHotelUpdate(false);
    setEditHotelSid('');
    setEditHotel(false);
    setEditApkProvider(false)
  }

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  useEffect(() => {
    if (!hotelList || hotelList?.length === 0) { return; }
    for (let item = 0; item < hotelList?.length; item++) {
      const apkTargetCdsn = watch('appName') || '';
      if (hotelList[item]?.appName === null || hotelList[item]?.appName === "" || hotelList[item]?.appName === undefined || apkTargetCdsn === '') {
        setConfirmAPICall(false);
      } else if (apkTargetCdsn !== hotelList[item]?.appName) {
        setConfirmAPICall(true);
      }
    }
  }, [watch('appName')])

  const handleItemsChange = (selected) => {
    setSelectedCdsns(selected);
  };

  // useEffect(() => {
  //   const filterCdsns = [...new Set([...watch('cdsns'), ...selectedCdsns])]
  //   setValue('cdsns', filterCdsns)
  // }, [selectedCdsns])

  const cancelCdsnHandler = () => {
    setShowChainIdPopup(false);
    setValue('hotelChainId', '');
    setSelectedCdsns([]);
    setCdsnsList([]);
    setOriginalCdsns([]);
  }

  const addCdsnHandler = () => {
    const filterCdsns = [...new Set([...watch('cdsns'), ...selectedCdsns])]
    setValue('cdsns', filterCdsns)

    setShowChainIdPopup(false);
    setValue('hotelChainId', '');
    setSelectedCdsns([]);
    setCdsnsList([]);
  }

  // Function to handle data from child
  const handleDataFromChild = (data) => {
    const filterCdsns = [...new Set([...watch('cdsns'), ...data.map(num => num.toString())])]
    setValue('cdsns', filterCdsns)
  };

    const handleSearch = (search) => {
      setSearchText(search)
    };

  const delayedSearch = useCallback(
    debounce((searchText) => handleSearch(searchText), 600),
    []
  );

  const sendOtp = (row) =>{
      setLoader(true);
      setCounter(60);
      setIsLinkDisabled(true)
      setTargetCdsnError("")
      callAPI(`/generateOtp?operationType=DELETE_HOTEL`, "POST", {} , { chainId: row?.row?.chainID.toString() })
          .then((response) => {
              setOtpSendSuccess(response);
              setLoader(false);
          })
          .catch((err) => {
              console.warn(err.message);
              setOtpSendError(err.message)
                setLoader(false);
          });
  }

  const clearData = ()=>{
      setOtp("")
      setIsLinkDisabled(false);
      setOtpSendError("");
      setOtpSendSuccess("");
      setOtpValidation("6 digit OTP Required")
      setTargetCdsnError("")
  }

  useEffect(()=>{
          if(otp.length<6){
              setOtpValidation("6 digit OTP Required")
          }
          else{
              setOtpValidation("")
          }
      },[otp])
  
    useEffect(() => {
        if (counter > 0) {
          const timeout = setTimeout(() => {
            setCounter((prevCounter) => prevCounter - 1);
          }, 1000);
          return () => {
            clearTimeout(timeout);
          };
        } else {
          setIsLinkDisabled(false);
          setOtpSendError("");
          setOtpSendSuccess("");
        }
      }, [counter]);

  return (
    <div className='row config-hotel'>
      <div className='col-12 left-column'>
         {loader && <div style={{zIndex: "99999"}} className="circular-progress"><CircularProgress /></div>}
        {(Object.keys(editHotelSid).length > 0 || userRoleCode === "ROLE_SUPER_ADMIN") &&
          <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className="hotel-list-form">
            <div className="row">
              <div className="left-column-header">
                <p>{editHotelUpdate ? 'Edit Hotel Details' : 'Configuration New Hotel'}</p>
              </div>
              <div className="form-group-hotel col-6">
                <div className={`floating-label ${userRoleCode !== "ROLE_SUPER_ADMIN" ? 'disable-field' : ''}`}>
                  <FaHotel className="new-hotel-icons" />
                  <input
                    id="hotelName"
                    maxLength={35}
                    disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                    placeholder=""
                    {...register("hotelName", {
                      required: "Please Enter Hotel Name",
                      pattern: {
                        value: /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/,
                        message: "Only alphanumeric characters and single spaces between words are allowed",
                      },
                    })}
                  />
                  <label htmlFor="address">Enter Hotel Name</label>
                </div>
                {errors.hotelName && (
                  <small className="required">{errors.hotelName.message}</small>
                )}
              </div>
              <Tooltip title={`${roomTypeDisabled ? "Room Type not applicable for third party hotel apps" : ""}`} arrow>
                <div className="form-group-hotel col-6">
                  <div className={`floating-select-label ${roomTypeDisabled ? "btn-disable-permission" : ""}`} >
                    <Controller
                      name="roomTypes"
                      control={control}
                      rules={{
                        validate: value => {
                          if (viewType === 'hotelApp') return true; // No validation
                          return (Array.isArray(value) && value.length > 0) || 'Please Select Room Type';
                        }
                      }}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          className={`multiselectlist ${field.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                          limitTags={2}
                          disablePortal
                          multiple
                          // disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                          freeSolo
                          options={roomTypesMaster}
                          getOptionLabel={(option) => option.toString()}
                          onChange={(_, newValue) => {
                            field.onChange(newValue);
                          }}
                          value={field.value || []}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder=""
                              variant="outlined"
                              label="Select Room Type"
                              onFocus={() => setShowHintRoomType(true)}
                              onBlur={() => setShowHintRoomType(false)}
                              InputLabelProps={{
                                shrink: false,
                              }}
                            />
                          )}
                        />
                      )}
                    />
                    {errors.roomTypes && (
                      <p className="required text-start">{errors.roomTypes.message}</p>
                    )}
                    {showHintRoomType && (<p className="hint-text">Please press enter after each manually entered room type to save</p>)}
                  </div>

                </div>
              </Tooltip>
              <div className="form-group-hotel col-6">
                <div className={`floating-label ${userRoleCode !== "ROLE_SUPER_ADMIN" ? 'disable-field' : ''}`}>
                  <MdEmail className="new-hotel-icons" />
                  <input
                    id="email"
                    placeholder=""
                    maxLength={60}
                    disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                    {...register("email", {
                      required: "Please Enter Your Email",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                        message: "Enter Email in Correct format",
                      },
                    })}
                  />
                  <label htmlFor="address">Enter Email</label>
                </div>
                {errors.email && (
                  <small className="required">{errors.email.message}</small>
                )}
              </div>
              <div className="form-group-hotel col-6">
                <div className={`floating-label ${userRoleCode !== "ROLE_SUPER_ADMIN" ? 'disable-field' : ''}`}>
                  <MdCall className="new-hotel-icons" />
                  <input
                    id="contactNo"
                    placeholder=""
                    maxLength={12}
                    minLength={10}
                    disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                    {...register("contactNo", {
                      required: "Enter Contact Number",
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Invalid Contact number",
                      },
                    })}
                  />
                  <label htmlFor="address">Enter Contact Number</label>
                </div>
                {errors.contactNo && (
                  <small className="required">{errors.contactNo.message}</small>
                )}
              </div>

              <div className="form-group-hotel col-3">
                <div className={`floating-label ${userRoleCode !== "ROLE_SUPER_ADMIN" ? 'disable-field' : ''}`}>
                  <MdLocationPin className="new-hotel-icons" />
                  <input
                    id="address"
                    disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                    placeholder=""
                    // maxLength={32}
                    {...register("address", {
                      required: "Please Enter City Name",
                      pattern: {
                        value: /^[a-zA-Z\s]*$/,
                        message: "Enter Alphabets only",
                      },
                      maxLength: {
                        value: 32,
                        message: "Maximum length is 32 characters",
                      }
                    })}
                  />
                  <label htmlFor="address">Enter City Name</label>
                </div>
                {errors.address && (
                  <small className="required">{errors.address.message}</small>
                )}
              </div>

              <div className="form-group-hotel col-3">
                <div className={`floating-label ${userRoleCode !== "ROLE_SUPER_ADMIN" ? 'disable-field' : ''}`}>
                  <MdLocationPin className="new-hotel-icons" />
                  <input
                    id="zipCode"
                    disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                    placeholder=""
                    // maxLength={32}
                    {...register("zipCode", {
                      required: "Please Enter Zipcode",
                      pattern: {
                        value: /^[0-9\s]*$/,
                        message: "Enter Digits only",
                      },
                      maxLength: {
                        value: 6,
                        message: "Maximum length is 6 digits",
                      },
                      minLength: {
                        value: 5,
                        message: "Minimum length is 5 digits",
                      }
                    })}
                  />
                  <label htmlFor="address">Enter Zipcode</label>
                </div>
                {errors.zipCode && (
                  <small className="required">{errors.zipCode.message}</small>
                )}
              </div>

              <div className="form-group-hotel col-6">
                <div className="row">
                  <div className="col-6">
                    <div className={`floating-label ${userRoleCode !== "ROLE_SUPER_ADMIN" ? 'disable-field' : ''}`}>
                      <MdLocationPin className="new-hotel-icons" />
                      <input
                        id="latitude"
                        disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                        placeholder=""
                        {...register("latitude", {
                          required: "Please Enter Latitude",
                          pattern: {
                            value: /^-?[0-9]+(\.[0-9]*)?$/,
                            message: "Only numbers and dots are allowed"
                          }
                        })}
                      />
                      <label htmlFor="latitude">Enter Latitude</label>
                    </div>
                    {errors.latitude && (
                      <small className="required">{errors.latitude.message}</small>
                    )}
                  </div>
                  <div className="col-6">
                    <div className={`floating-label ${userRoleCode !== "ROLE_SUPER_ADMIN" ? 'disable-field' : ''}`}>
                      <MdLocationPin className="new-hotel-icons" />
                      <input
                        id="longitude"
                        disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                        placeholder=""
                        {...register("longitude", {
                          required: "Please Enter Longitude",
                          pattern: {
                            value: /^-?[0-9]+(\.[0-9]*)?$/,
                            message: "Only numbers and dots are allowed"
                          }
                        })}
                      />
                      <label htmlFor="longitude">Enter Longitude</label>
                    </div>
                    {errors.longitude && (
                      <small className="required">{errors.longitude.message}</small>
                    )}
                  </div>
                </div>
              </div>
              {editHotelUpdate && <div className="form-group-hotel col-6">
                <button type="button" className="clear-btn me-2" onClick={() => setShowChainIdPopup(true)}>Fetch Cdsn's From Chain Id</button>
                <UploadCDSNs handleDataFromChild={handleDataFromChild} />
              </div>}
              <div className="col-6 align-self-center form-group-hotel">
                <RadioGroup
                  row
                  name="viewType"
                  value={viewType}
                  onChange={(e) => { setViewType(e.target.value); setViewTypeOnChange((prev) => !prev) }}
                  className="h-auto main-events mt-0 mb-1"
                >
                  <FormControlLabel
                    value="custom"
                    control={<Radio />}
                    label="Tata Play Hotel Solution"
                    disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                  />
                  <FormControlLabel
                    value="hotelApp"
                    control={<Radio />}
                    label='Third Party Hotel Apps'
                    disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                  />

                </RadioGroup>
                {editHotelUpdate && viewTypeOnChange && <FormHelperText className="required-error">Changing Hotel Type will impact Room Configurations / APK Configurations</FormHelperText>}
              </div>
              {editHotelUpdate && <div className="form-group-hotel col-6">
  <div className="floating-select-label-color">
    <Controller
      name="cdsns"
      control={control}
      rules={{
        validate: (value) => {
          // Ensure value is an array
          if (!Array.isArray(value)) {
            return 'Invalid CDSN data';
          }

          // Check if required (for edit mode)
          if (editHotelUpdate) {
            if (originalCdsns.length && !value.length) {
              return 'Please Enter CDSNs';
            }
          }

          // Validate each CDSN
          for (let i = 0; i < value.length; i++) {
            const item = value[i];
            
            // Convert to string if it's not already
            const itemStr = typeof item === 'string' ? item : String(item);
            
            // Remove any whitespace
            const cleanItem = itemStr.trim();
            
            // Skip empty values
            if (!cleanItem) {
              return `CDSN at position ${i + 1} is empty`;
            }
            
            // Check if it contains only numbers
            if (!/^\d+$/.test(cleanItem)) {
              return `CDSN "${cleanItem}" must contain only numbers`;
            }
            
            // Check exact length of 10
            if (cleanItem.length !== 10) {
              return `CDSN "${cleanItem}" must be exactly 10 digits (current: ${cleanItem.length})`;
            }
          }
          
          return true;
        },
      }}
      render={({ field }) => (
        <Autocomplete
          {...field}
          className={`multiselectlist ${field.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
          limitTags={2}
          disablePortal={false}
          multiple
          freeSolo
          options={watch('cdsns') || []}
          
          // Ensure consistent string handling
          getOptionLabel={(option) => {
            return typeof option === 'string' ? option : String(option);
          }}
          
          // Proper filtering for search
          filterOptions={(options, { inputValue }) => {
            if (!inputValue) return options;
            return options.filter(option => {
              const optionStr = typeof option === 'string' ? option : String(option);
              return optionStr.includes(inputValue);
            });
          }}
          
          // Handle input changes for search
          onInputChange={(event, newInputValue, reason) => {
            if (reason === 'input') {
              // Optional: Add search logic here
              console.log('Searching for:', newInputValue);
            }
          }}
          
          onChange={(_, newValue, reason, details) => {
            if (reason === "clear") {
              setPendingClear(() => () => field.onChange([]));
              setCancelPopupClearHotel(true);
              return;
            }

            // Handle the new value properly
            let processedValue = [];
            
            if (Array.isArray(newValue)) {
              processedValue = newValue.map(item => {
                // Convert to string and trim
                const str = typeof item === 'string' ? item.trim() : String(item).trim();
                return str;
              }).filter(item => item !== ''); // Remove empty strings
            }
            
            // Update the field value
            field.onChange(processedValue);
            
            // Trigger validation immediately
            setTimeout(() => {
              trigger('cdsns');
            }, 0);
          }}
          
          value={field.value || []} // Ensure always an array
          
          renderOption={(props, option) => (
            <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
              {typeof option === 'string' ? option : String(option)}
              <IconButton
                edge="end"
                aria-label="remove"
                style={{ marginLeft: 'auto' }}
                onClick={(e) => {
                  e.stopPropagation();
                  const currentValues = field.value || [];
                  const newValues = currentValues.filter(item => {
                    const itemStr = typeof item === 'string' ? item : String(item);
                    const optionStr = typeof option === 'string' ? option : String(option);
                    return itemStr !== optionStr;
                  });
                  field.onChange(newValues);
                  // Trigger validation after removal
                  setTimeout(() => {
                    trigger('cdsns');
                  }, 0);
                }}
              >
                <ClosedIcon />
              </IconButton>
            </li>
          )}
          
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Type to search or add CDSN..."
              variant="outlined"
              label="Select CDSN's"
              onFocus={() => setShowHintCdsns(true)}
              onBlur={(e) => {
                setShowHintCdsns(false);
                
                // Handle manual entry when user types and blurs
                const inputValue = e.target.value?.trim();
                if (inputValue && !field.value?.includes(inputValue)) {
                  const newValues = [...(field.value || []), inputValue];
                  field.onChange(newValues);
                  // Clear the input
                  e.target.value = '';
                  // Trigger validation
                  setTimeout(() => {
                    trigger('cdsns');
                  }, 0);
                }
              }}
              onKeyDown={(e) => {
                // Handle Enter key for adding new CDSN
                if (e.key === 'Enter') {
                  e.preventDefault();
                  const inputValue = e.target.value?.trim();
                  if (inputValue && !field.value?.includes(inputValue)) {
                    const newValues = [...(field.value || []), inputValue];
                    field.onChange(newValues);
                    // Clear the input
                    e.target.value = '';
                    // Trigger validation
                    setTimeout(() => {
                      trigger('cdsns');
                    }, 0);
                  }
                }
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
      )}
    />
    {errors.cdsns && (
      <p className="required text-start">{errors.cdsns.message}</p>
    )}
    {showHintCdsns && (
      <p className="hint-text">
        Type to search existing CDSNs or press Enter to add new CDSN (must be 10 digits)
      </p>
    )}
  </div>
</div>
}
              {(userRoleCode !== "ROLE_SUPER_ADMIN" && viewType === "hotelApp") && <div className="form-group-hotel col-6">
                <div className="floating-select-label">
                  <Controller
                    name="appName"
                    control={control}
                    rules={{
                      validate: value =>
                        (value !== undefined && value !== null && value !== '') || 'Please Select APK Provider'
                    }}
                    render={({ field }) => (
                      <Autocomplete
                        {...field}
                        className={`multiselectlist ${field.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                        disablePortal
                        freeSolo
                        options={appNameMasterList}
                        getOptionLabel={(option) => option.toString()}
                        onChange={(_, newValue) => {
                          field.onChange(newValue);
                          setEditApkProvider(true)
                        }}
                        value={field.value || []}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder=""
                            variant="outlined"
                            label="Select APK Provider"
                            InputLabelProps={{
                              shrink: false,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                  {errors.appName && (
                    <p className="required text-start">{errors.appName.message}</p>
                  )}
                </div>
                {editHotelUpdate && editApkProvider && <FormHelperText className="required-error">Changing APK Provider Name will delete all existing APK Configurations</FormHelperText>}
              </div>}
              {userRoleCode === "ROLE_SUPER_ADMIN" && <div className="form-group-hotel col-6">
                <div className="row">
                  <div className="col-6 d-flex align-items-center">
                    <Tooltip title={`${watch("autoMode") ? "Enabled" : "Disabled"}`} arrow>
                      <Controller
                        name="autoMode"
                        control={control}
                        render={({ field }) => (
                          <Switch
                            {...field}
                            checked={field.value}
                            onChange={(event, checked) => {
                              field.onChange(checked); // Call react-hook-form's onChange
                              // Your custom onChange logic here
                              if(checked) setValue("priority", "MEDIUM");
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                            className={`${field.value === false ? 'switchuser-inactive' : 'switchuser-active'} edit-icon-disable cursor-pointer`}
                          />
                        )}
                      />
                    </Tooltip>
                    <div className="auto-mode">
                      Auto Mode ( <span className={`${watch("autoMode") ? "automode-enabled" : "automode-disabled"}`}>{`${watch("autoMode") ? "Enabled" : "Disabled"}`}</span> )</div>
                  </div>
                  <div className="col-6">
                    <div className={`floating-label`}>
                      <GiBreakingChain className="new-hotel-icons" />
                      <input
                        id="enterpriseChainId"
                        // disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                        placeholder=""
                        {...register("enterpriseChainId", {
                          required: watch("autoMode") ? "Please Enter Chain Id" : false,
                          pattern: {
                            value: /^-?[0-9]+(\[0-9]*)?$/,
                            message: "Only numbers are allowed"
                          }
                        })}
                      />
                      <label htmlFor="enterpriseChainId">Enter Chain Id</label>
                    </div>
                    {errors.enterpriseChainId && (
                      <small className="required">{errors.enterpriseChainId.message}</small>
                    )}
                  </div>
                  {watch("autoMode") && <div className="col-6">
                      <Controller
                        name="priority"
                        control={control}
                        defaultValue="MEDIUM"
                        render={({ field }) => (
                          <RadioGroup
                            row
                            value={field.value}   // <-- explicitly set value
                            onChange={field.onChange} // <-- explicitly handle onChange
                            className="h-auto main-events mt-0 mb-1"
                          >
                            <FormControlLabel
                              value="HIGH"
                              control={<Radio />}
                              label="High"
                            />
                            <FormControlLabel
                              value="MEDIUM"
                              control={<Radio />}
                              label="Medium"
                            />
                            <FormControlLabel
                              value="LOW"
                              control={<Radio />}
                              label="Low"
                            />
                          </RadioGroup>
                        )}
                      />
                    </div>}
                  {/* <div className="col-4">
                    <div className={`floating-label ${userRoleCode !== "ROLE_SUPER_ADMIN" ? 'disable-field' : ''}`}>
                      <MdLocationPin className="new-hotel-icons" />
                      <input
                        id="maxDuration"
                        disabled={userRoleCode !== "ROLE_SUPER_ADMIN"}
                        placeholder=""
                        {...register("maxDuration", {
                          required: "Please Enter Max Duration",
                          pattern: {
                            value: /^-?[0-9]+(\[0-9]*)?$/,
                            message: "Only numbers are allowed"
                          }
                        })}
                      />
                      <label htmlFor="maxDuration">Max Duration (in Days)</label>
                    </div>
                    {errors.maxDuration && (
                      <small className="required">{errors.maxDuration.message}</small>
                    )}
                  </div> */}
                </div>
                {watch("autoMode") && <p className="periodic-check"><span>Note: </span>Periodic Check will be done after every {`${watch("priority")==="HIGH"?"35 Minutes":watch("priority")==="MEDIUM"?"2 Hours":"24 Hours at 12:00 AM"}`} .</p>}
              </div>}
              <div className="col-12 form-group-hotel text-end">
                <button type="button" className="clear-btn me-2" onClick={cancelHotelHandler}>{editHotelUpdate ? "Cancel" : "Clear All"}</button>
                {editHotelUpdate && <>
                  <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                </>}
                <button type="submit" className={`create-btn ${validPermissionClassName}`}>{editHotelUpdate ? "Update" : "Create"}</button>

              </div>
            </div>
          </form>
        }
        {(viewTypePermission === "hotelApp" && userRoleCode !== "ROLE_SUPER_ADMIN") && <UploadApk disableAPKFlag={disableAddNewAPK} viewType={viewTypePermission} setLoader={setLoader} hotelDetails={hotelList} createUpdateFlag={createUpdateFlag} />}
        <div className="hotel-list">
          <div className="flex-items-between mb-3">
            <p className="mb-0"><b>Hotels List</b></p>
            <div className="form-group-hotel mb-0">
              <div className={`floating-label`}>
                <input
                  id="search"
                  placeholder=""
                  className="form-control"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!value) {
                      setSelectedPage(1);
                      setInputPageValue(1);
                    }
                    delayedSearch(value)
                  }}
                />
                <label htmlFor="guestName">Search Hotel</label>
              </div>
            </div>
          </div>
          <TableWrapper
            data={hotelList}
            columns={columns}
            module="hotel-config"
            noPagination={true}
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
      </div>

      {/* <ConfigrationActions /> */}
      {deleteHotelPopUp && <BasicModal
        popupOpen={deleteHotelPopUp}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel">{isHotelDeletedRef.current?.isHotelDeletedModalData ?
            <div className="confirm-delete-hotel">
              <p>Do you really want to Delete Hotel " <b>{isHotelDeletedRef.current?.isHotelDeletedModalData.row.hotelName}</b> " ?</p>
              <p className="warning"><IoMdWarning /> Warning</p>
              <p>Hotel "{isHotelDeletedRef.current?.isHotelDeletedModalData.row.hotelName}" will be permanently deleted <br />
                Deleting the specified Hotel can't be undone.
              </p>
              <p className="mt-3">To confirm deletion, type "Delete {isHotelDeletedRef.current?.isHotelDeletedModalData.row.hotelName}"</p>
              {otpSendSuccess && <p className="text-success text-capitalize">{otpSendSuccess}</p>}
              {otpSendError && <p className="text-danger text-capitalize">{otpSendError}</p>}
              {targetCdsnError && <p className="text-danger text-capitalize">{targetCdsnError}</p>}
              <div className="form-group-hotel mt-3">
                <div className="floating-label">
                  <input
                    id="deleteHotel"
                    placeholder=""
                    onChange={(e) => setConfirmDeleteHotel(e.target.value)}
                  />
                  <label htmlFor="address">Delete Hotel</label>
                </div>
                {(confirmDeleteHotel === "" && confirmValidate) ? (
                  <small className="required">Please Enter delete hotel</small>
                ) : (confirmDeleteHotel !== `${isHotelDeletedRef.current?.isHotelDeletedModalData.row.hotelName}` && confirmValidate) ? (
                  <small className="required">Please Enter delete hotel s</small>
                ) : ""
                }
              </div>
              <div className="flex-items-between">
              <div className="form-group-hotel mb-0 col-4">
                  <div className={`floating-label`}>
                      <input
                      id="otp"
                      maxLength={6}
                      placeholder=""
                      value={otp}
                      className="form-control"
                      onChange={(e)=>setOtp(e.target.value)}
                      />
                      <label htmlFor="searchAction">Enter OTP</label>
                  </div>
                  {otpValidation && (
                  <small className="required">{otpValidation}</small>
                  )}
                  </div>
                  <div className="col-3 ms-2">
                      <button type="button" disabled={isLinkDisabled} onClick={()=>sendOtp(isHotelDeletedRef?.current?.isHotelDeletedModalData)} className={`create-btn ${isLinkDisabled?"btn-disable opacity-50":""}`}>Send OTP</button>
                      {isLinkDisabled && (
                  <small className="required">Resend OTP in {counter} Sec</small>
                  )}
                  </div>
              </div>
              
            </div> :
            isHotelDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isHotelDeletedRef.current?.isHotelDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: ()=>{popupCloseHandler();clearData()}
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: ()=>{deleteHotelHandler(); clearData()},
                buttonSecondaryCustomCss: otpValidation!=='' ? "btn-disable" : ""
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: popupCloseHandler
              }
            }
        }
      />}
      <BasicModal
        popupOpen={cdnsShowPopUp}
        bodyMessage={
          <div className="text-start">
            <p className="px-3 pt-3">List of "<b>{rowData?.hotelName}</b>" Linked CDSNs</p>
            <div className="linked-sid-cdsns">
              <div className="sid-cdsn-list">
                <div className="row sid-cdsn-list-header">
                  <h6 className="text-start">CDSN's</h6>
                </div>
                <div className="my-3 px-3">
                {rowData?.cdsns?.map((items, index) =>
                  <span className="mb-1">{index?', ': ''} {items}</span>
                )}
                </div>
              </div>
            </div>
          </div>
        }
        customcss={true}
        footer={
          {
            primaryButton: {
              buttonName: "Cancel",
              action: popupCloseHandler,
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
            ,
            secondaryButton: {
              buttonName: "Download",
              action: downLoadFile
            }
          }
        }
      />

      {/* {addCdnsShowPopUp && <BasicModal
        popupOpen={addCdnsShowPopUp}
        heading={<div>Linked SID & CDSNS with Chain Id: <b>{watch('hotelChainId')}</b></div>}
        bodyMessage={<div className="linked-sid-cdsns">
          <div className="sid-cdsn-list">
            <div className="row sid-cdsn-list-header">
              <h6 className="col-4 text-start">SID's</h6>
              <h6 className="col-4 text-start">CDSN's</h6>
            </div>
            {sidCdsnPayload?.map((items) => <>
              <div className="row sid-cdsn-list-body">
                <p className="col-4">{items?.sid}</p>
                <div className="col-4">
                  {items?.cdsn?.map((item, index) =>
                    <span>{index ? ', ' : ''}{item}</span>
                  )}
                </div>
              </div>
            </>
            )}
          </div>
        </div>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => {
                setAddCdnsShowPopUp(false);
              },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />} */}
      <BasicModal
        popupOpen={createHotelSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createHotelSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateHotelSuccessMsg(''); setEditHotelUpdate(false); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />

      <BasicModal
        popupOpen={confirmAPICalling}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">Changing APK Name will clear existing APK List details. Do you want to proceed?</p>}
        footer={
          {
            primaryButton: {
              buttonName: "Cancel",
              action: () => { setConfirmAPICalling(false); }
            },
            secondaryButton: {
              buttonName: "Update",
              action: () => { setConfirmAPICall(false); handleSubmit(onSubmit)() },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
      {deleteLogo && <BasicModal
        popupOpen={deleteLogo}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel">{isHotelLogoDeletedRef.current?.isHotelLogoDeletedModalData ?
            <p className="mt-2">Do you really want to Delete existing Logo?</p> :
            isHotelLogoDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isHotelLogoDeletedRef.current?.isHotelLogoDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: () => { setDeleteLogo(false); }
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: deleteImageHandler
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: () => { setDeleteLogo(false); }
              }
            }
        }
      />}
      {showChainIdPopup && <BasicModal
        popupOpen={showChainIdPopup}
        popupSize='col-8 p-4'
        bodyMessage={<><div className="form-group-hotel w-50">
          <div className="chain-id">
            <div className="floating-label">
              <MdInsertLink className="new-hotel-icons" />
              <input
                id="hotelChainId"
                maxLength={20}
                placeholder=""
                {...register("hotelChainId", {
                  required: "Please Enter chain Id",
                  pattern: {
                    value: /^[a-zA-Z0-9]+$/,
                    message: "Only alphanumeric characters are allowed",
                  },
                })}
                onKeyDown={handleKeyPress}
                onFocus={() => setShowHintChainId(true)}
                onBlur={() => setShowHintChainId(false)}
              />
              <label htmlFor="address">Enter chain Id</label>
            </div>
            <button type="button" disabled={watch('hotelChainId') === ""} className="clear-btn" onClick={handleKeyPress}>Fetch Cdsn's</button>
          </div>
          {errors.hotelChainId && (
            <p className="required text-start mb-0">{errors.hotelChainId.message}</p>
          )}
          {chainIdApiErrorValidation.length !== "" && (
            <p className="required text-start mb-0">{chainIdApiErrorValidation}</p>
          )}
          {showHintChainId && (<p className="hint-text">Please press enter to get linked CDSN's with the Chain ID</p>)}
        </div>
          <DualListBox
            listTitle="List Of CDSN's"
            selectedListTitle="Selected CDSN's"
            items={cdsnsList.filter((item) => !selectedCdsns?.includes(item))}
            initialData={selectedCdsns}
            onChange={(selected) => handleItemsChange(selected)}
          />
        </>
        }
        footer={{
          primaryButton: {
            buttonName: "Cancel",
            action: cancelCdsnHandler
          },
          secondaryButton: {
            buttonName: "Add Cdsn's",
            action: addCdsnHandler
          }
        }
        }
      />}
      <BasicModal
              popupOpen={cancelPopupClearHotel}
              bodyMessage={"Do you really want to Remove all CDSN's?"}
              logo={"/Images/Rejected.png"}
              footer={{
                primaryButton: {
                  buttonName: "Cancel",
                  action: () => {
                    setCancelPopupClearHotel(false);
                    setPendingClear(null);
                  },
                },
                secondaryButton: {
                  buttonName: "Yes",
                  action: cancelPopupHandlerClearHotel,
                },
              }}
            />
    </div>
  )
}

export default ConfigurationNewHotel;